import {
	STATUS_BADGE_TONE_PALETTES,
	type StatusBadgePalette,
} from "@/shared/components/status-badge";

export const VEHICLE_STATUS_LABELS = {
	Available: "Disponível",
	InMaintenance: "Manutenção",
	Inactive: "Inativo",
};
export const VEHICLE_STATUS_COLORS = {
	Available: "bg-[#17B26A]",
	InMaintenance: "bg-[#F79009]",
	Inactive: "bg-[#F04438]",
};
export const VEHICLE_STATUS_BY_ID_LABELS = {
	1: "Disponível",
	2: "Manutenção",
	3: "Inativo",
};
export const VEHICLE_STATUS_BY_ID_COLORS = {
	1: "bg-[#17B26A]",
	2: "bg-[#F79009]",
	3: "bg-[#F04438]",
};

export const VEHICLE_STATUS_BADGE_PALETTES: Record<
	keyof typeof VEHICLE_STATUS_LABELS,
	StatusBadgePalette
> = {
	Available: STATUS_BADGE_TONE_PALETTES.success,
	InMaintenance: STATUS_BADGE_TONE_PALETTES.warning,
	Inactive: STATUS_BADGE_TONE_PALETTES.error,
};

export const VEHICLE_STATUS_BADGE_PALETTES_BY_ID: Record<
	keyof typeof VEHICLE_STATUS_BY_ID_LABELS,
	StatusBadgePalette
> = {
	1: STATUS_BADGE_TONE_PALETTES.success,
	2: STATUS_BADGE_TONE_PALETTES.warning,
	3: STATUS_BADGE_TONE_PALETTES.error,
};
